// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1e25_","log":"ModalInventoryLogs_log__15lWd","date":"ModalInventoryLogs_date__2dR8J","userName":"ModalInventoryLogs_userName__2XWmV"};